<template>
    <section>
        <o-field>
            <o-input placeholder="small" size="small" icon="user" />
        </o-field>

        <o-field>
            <o-input placeholder="default" icon="user" />
        </o-field>

        <o-field>
            <o-input placeholder="medium" size="medium" icon="user" />
        </o-field>

        <o-field>
            <o-input placeholder="Large" size="large" icon="user" />
        </o-field>
    </section>
</template>
